// Curated maintenance videos (real, verified YouTube IDs; embedded via
// youtube-nocookie). Checked against oEmbed 2026-08-02.
import type { VideoItem } from '@/shared/components/VideoGrid.vue'

export const VIDEOS: VideoItem[] = [
    {
        id: 'OvBIlG6pYl0',
        title: 'How to change your HVAC air filter',
        blurb: 'The 2-minute habit that prevents half of all cooling failures. (WIN Home Inspection)',
    },
    {
        id: '_M-JLzIQHtk',
        title: 'Clean your condenser coil, step by step',
        blurb: 'A garden hose and 20 minutes can noticeably improve cooling. (AmplifyDIY)',
    },
    {
        id: 'sL8LJnKaul0',
        title: 'Unclog your AC drain line with vinegar',
        blurb: 'Stop the most common cause of AC water leaks for under $3. (CreativeProcessDIY)',
    },
    {
        id: '-33wjzNxgSw',
        title: 'How to repair a frozen air conditioner',
        blurb: 'Why coils ice up and what to do about it. (Ask This Old House)',
    },
    {
        id: 'FaDG_t32XYs',
        title: 'How experts troubleshoot an AC system',
        blurb: 'Watch a pro work the same checklist our guides teach. (Ask This Old House)',
    },
    {
        id: 'EAsPUvpvDUE',
        title: 'HVAC maintenance checklist for homeowners',
        blurb: 'The full seasonal routine in one video. (HomeMembership)',
    },
]
